"use strict";

exports.__esModule = true;
exports.LiveTimelineQueryController = LiveTimelineQueryController;
var _react = _interopRequireDefault(require("react"));
var _libTimeline = require("@vimana/lib-timeline");
var _TimelineQueryController = require("../TimelineQueryController");
var _TimelineSubscription = require("../TimelineSubscription");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var updateTimeline = (0, _libTimeline.createTimelineModifier)({
  minimumDuration: 10
});

/**
 * Queries a given timeline, subscribes to realtime updates and
 * makes the results available to consumers via a render prop.
 */
function LiveTimelineQueryController(_ref) {
  var timelineName = _ref.timelineName,
    interval = _ref.interval,
    query = _ref.query,
    children = _ref.children;
  return /*#__PURE__*/_react["default"].createElement(_TimelineQueryController.TimelineQueryController, {
    timelineName: timelineName,
    interval: interval,
    query: query
  }, function (queryConsumerProps) {
    return /*#__PURE__*/_react["default"].createElement(_TimelineSubscription.TimelineSubscription, {
      timelineName: timelineName,
      query: query,
      isCurrent: false,
      onData: function onData(packet) {
        return packet != null && (0, _libTimeline.isIntervalOverlapping)(interval, packet.interval) && queryConsumerProps.update(function (timeline) {
          return updateTimeline(timeline || [], packet);
        });
      }
    }, function (value) {
      return value instanceof Error ? children(Object.assign({}, queryConsumerProps, {
        error: value
      })) : children(queryConsumerProps);
    });
  });
}